import { Row } from "@tanstack/react-table";
import { format } from "date-fns";
import { AppSessionsTableType } from "../types/appSession.type";

export function exportAsCSV<TData extends AppSessionsTableType>(
  data: Row<TData>[],
  fileName: string = "analytics_data.csv"
): Promise<void> {
  return new Promise((resolve) => {
    let res = data.map(
      ({
        original: {
          appName,
          userId,
          userEmail,
          ownerOrganization,
          accessType,
          startTime,
          endTime
        },
        getValue
      }) => {
        const formattedAccessType =
          accessType[0] + accessType.substring(1).toLocaleLowerCase();
        const duration = getValue("sessionDuration");
        const formattedStartTime = format(startTime, "y-MM-dd HH:mm:ss");
        const formattedEndTime = endTime && format(endTime, "y-MM-dd HH:mm:ss");

        return `"${appName}","${userId}","${userEmail}","${ownerOrganization}","${formattedAccessType}","${formattedStartTime}","${formattedEndTime}","${duration}"`;
      }
    );

    res.unshift(
      `"App","User ID","User Email","Owner Organization","Access Type","Start time","End time","Duration in seconds"`
    );

    const content = res.join("\r\n");

    const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", fileName);
    a.click();

    resolve();
  });
}
